import { reject } from 'lodash';

export const addNotification = (state, notification) => {
    const notificationsCopy = [...state.notifications];

    notificationsCopy.push(notification);

    return notificationsCopy;
};

export const removeNotification = (state, key) => {
    const notificationsCopy = [...state.notifications];

    return reject(notificationsCopy, ['key', key]);
};
